import styles from 'core-components/sitebuilder/layout/FlexGrid.module.scss'
import { FlexDirectionBreak } from 'core-components/sitebuilder/models/flexGrid/FlexDirectionBreak'

export const getClassByFlexDirectionBreak = (value: FlexDirectionBreak): string => {
  switch (value) {
    case FlexDirectionBreak.p112:
      return styles['col-1']
    case FlexDirectionBreak.p212:
      return styles['col-2']
    case FlexDirectionBreak.p312:
      return styles['col-3']
    case FlexDirectionBreak.p412:
      return styles['col-4']
    case FlexDirectionBreak.p512:
      return styles['col-5']
    case FlexDirectionBreak.p612:
      return styles['col-6']
    case FlexDirectionBreak.p712:
      return styles['col-7']
    case FlexDirectionBreak.p812:
      return styles['col-8']
    case FlexDirectionBreak.p912:
      return styles['col-9']
    case FlexDirectionBreak.p1012:
      return styles['col-10']
    case FlexDirectionBreak.p1112:
      return styles['col-11']
    case FlexDirectionBreak.p1212:
      return styles['col-12']
  }
  return ''
}
